export const generateSafeId = (value: string): string => {
  return value
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]/g, ''); // Remove anything that's not word characters or hyphen
};
